<template>
	<b-container class="show-document">

		<div class="doc-body">
			<div class="actions mb-2 mt-2 hidden-print">
				<div class="pull-left">
					<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{
						$t('back') }}
					</b-button>
				</div>
				<div class="pull-right">
					<b-button
						variant="outline-dark"
						class="mr-2"
						@click="print"
					>
						<i class="fa fa-print"></i>
						Печать Штрихкод
					</b-button>

					<div class="clearfix"></div>
				</div>
				<div class="clearfix"></div>


			</div>


			<div v-if="currentItems.length>0">
				<template v-for="product in currentItems">
					<div class="printElement  mb-2 text-center"  v-for="index in parseInt(product.count)">
						<p style="margin-left:100px" class="pb-1">{{product.itemBarcode}} </p>
						<div class="div1" style="display:flex;flex-direction: row;justify-content: center;">
							<div  style="display:flex;flex-direction: column;" class="mr-3">
							<span style="align-self: start">{{$t('promo-to-product.initial-price')}}</span>
							<h5 class="h3">{{product.itemPriceUzs | currency({symbol: product.currencyName, fractionCount: 0, symbolPosition: 'back',thousandsSeparator: ''
                             		})}}</h5>
							</div>
							<div style="display:flex;flex-direction: column;" class="ml-4">
							<span style="align-self: start">{{$t('promo-to-product.discount-price')}}</span>
							<h5>{{product.discountPriceUzs | currency({symbol: product.currencyName, fractionCount: 0, symbolPosition: 'back',thousandsSeparator: ''
                               }) }}</h5>
							</div>
						</div>
						<div style="display:flex;flex-direction: row;justify-content: center;margin-left:70px;margin-top:15px">
						<span class="mt-2 mr-2">{{$t('promo-to-product.discount')}}</span>
						<h5>
                       		<span v-if="product.promoType == '%'">{{product.promoType}}{{product.discount}}</span>
							<span v-else>{{product.discount | currency({symbol: product.currencyName, fractionCount: 0, symbolPosition: 'back',thousandsSeparator: ''
                               }) }}</span>
                        </h5>
						</div>
				</div>
				</template>
			</div>
		</div>
	</b-container>
</template>

<script>
import {mapState} from 'vuex';
// import WhDocument from "../../../../services/wh-document.service";

	export default {
		name: 'BarcodeDiscount',
		computed: {
			...mapState('promo',['currentItems']),
			...mapState(['userDepCurrencyName']),
		},
		methods: {
			async removePageSizeStyle() {
				var el = document.getElementById('stylePrintSizeId');
				if (el) {
					el.remove(); // Removes the div with the 'stylePrintSizeId' id
				}
			},
			async setPageSizeStyle(sizeValue) {
				var css = `@page { size: ${sizeValue}; }`,
				head = document.head || document.getElementsByTagName('head')[0],
				style = document.createElement('style');

				style.type = 'text/css';
				style.media = 'print';
				style.id = 'stylePrintSizeId';

				if (style.styleSheet){
					style.styleSheet.cssText = css;
				} else {
					style.appendChild(document.createTextNode(css));
				}

				head.appendChild(style);
			},
			async goBackToFrom() {
				await this.$router.back();
				await this.$store.commit('promo/setItemsForBarcode', null)
      			await this.$store.commit('promo/setTotalForBarcode', 0)

			},
			async print(){
				await this.removePageSizeStyle();
				await this.setPageSizeStyle('landscape');
				window.print();

			}
		},

	}
</script>

<style scoped>
span {
	font-size: 15px;
}
	h5 {
	font-size:22px;
	}
	.h3{
      position: relative;
      font-size:22px;
    }
    .h3::after{
	  border-radius: 0px 100px 0px 100px ;
      content: "";
      width: 100%;
      height: 2px;
      background: black;
      position: absolute;
      bottom: 25px;
      left: 0;
      transform: rotateZ(-30deg);
    }
    .h3::before{
          content: "";
          width: 100%;
          height: 2px;
          background: black;
          position: absolute;
          bottom: 25px;
          left: 0;
          transform: rotateZ(30deg);
		  border-radius: 100px 0 100px 0;
        }
	/* body {
		background-color: white !important;
	} */
	@page {
		margin: 0;
	}
	@media print {
		html, body {

			margin: 0 !important;
			/* text-align: center; */
			padding: 0 !important;
		}

		/* @page { size: landscape; } */
		.hidden-print {
			display: none;
		}
		.printElement .h3{
			position: relative;
			font-weight: bold;
			color: #000000 !important;

		}
		.h3::after{
			border-radius: 0px 100px 0px 100px ;
			content: "";
			display: block;
			width: 100%;
			height: 2px;
			background-color: black !important;
			-webkit-print-color-adjust: exact;
			position: absolute;
			bottom: 25px;
			display:block;
			left: 0;
			transform: rotateZ(-30deg);
		}
		.h3::before{
			border-radius: 100px 0 100px 0;
			content: "";
			display: block;
			width: 100%;
			height: 2px;
			background-color: black !important;
			-webkit-print-color-adjust: exact;
			position: absolute;
			bottom: 25px;
			left: 0;
			transform: rotateZ(30deg)
			}
		.printElement {
			font-weight: bold;
			margin-top: 2.5% !important;
			margin-bottom: 0 !important;
			/* text-align: center; */
			/* margin-left: 1% !important; */
			page-break-after: always;
			word-break:break-all;
			width: 80mm !important;
			height: 35mm !important;
			color: #000000 !important;
		}
		 .printElement p {
			font-family:"Arial Black", Gadget, sans-serif;
			font-weight: bold;
			 margin-left:90px !important;
			width: 100%;
			color: #000000 !important;
			/* font-weight: bold; */
			/* page-break-inside: avoid; */
		}
		h5 {
			font-weight: bold !important;
			color: #000000 !important;
		}
		/* .info {
			font-size: 11px !important;
		} */

		/* .card {
			box-shadow: none;
		} */
		/* svg {
			width: 75mm !important; */
			/*margin-top: -1mm;*/
			/* position: relative;
			bottom: 0;
			left: 0;
		} */
		/* .prices {
			font-size: 20px !important;
		} */
	}


	p {
		margin-bottom: 0px;
		font-size: 11.5px;

	}


</style>
